import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, message, Upload } from 'antd';
import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph } = Typography;
const Hfpsc = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [ticks, setticks] = useState([]);// 选择的产品信息


  useEffect(() => {
    async function getau() {
      const res = await request.post('/hfpsc_list')
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const gohf = (v) => {
    setccpxx(v)
    formxf.setFieldsValue({ dbno: v.key });// 回传发送短信订单号码
    setOpen(true)

  }

  const token = localStorage.getItem('token_key')

  const props = {
    name: 'file',
    action: 'http://api.ddspp.com:30123/v3/Hfpsc_do',
    headers: {
      Authorization: `{"Bearer_ddspp":"${token}"}`,
    },
    data: { ddno: ccpxx.key },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        //  console.log(info.fileList[0].response.return_msg);//info.file, 
      }
      if (info.file.status === 'done') {
        setOpen(false)
        setticks(info.fileList[0].response.ticks)
        messageApi.open({ type: info.fileList[0].response.return_code, content: info.fileList[0].response.return_msg, });
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };



  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [

    {
      title: '业务编号',
      dataIndex: 'key',
      key: 'key',
      ...getColumnSearchProps('key'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: '用户编号',
      dataIndex: 'userid',
      key: 'userid',
      ...getColumnSearchProps('userid'),
    },
    {
      title: '开票类型',
      key: 'kpjson',
      render: (_, record) => (
        <Space size="middle">{record.kpjson[0].p_n3}
        </Space>
      ),
    },
    {
      title: '名称',
      key: 'kpjson',
      render: (_, record) => (
        <Space size="middle">{record.kpjson[0].p_n1}
        </Space>
      ),
    },
    {
      title: '金额',
      key: 'amount',
      ...getColumnSearchProps('amount'),
      dataIndex: 'amount',
    },

    {
      title: '开票状态',
      key: 'kpzt',
      ...getColumnSearchProps('kpzt'),
      dataIndex: 'kpzt',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {record.chqk === "true" && <Button style={{ "background": "linear-gradient(135deg, #6253e1, #04befe)" }} icon={<UploadOutlined />} id={record.key}
            onClick={() => gohf(record)}
          >上传发票</Button>}

        </Space>
      ),
    },
  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
      

            <Table
              // rowSelection={   {type:"checkbox",...rowSelection,}} 
              columns={columns} dataSource={bangm} />

        



        </div>


        <Modal
          // title="开票信息表"
          footer={null}
          centered
          open={open}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          {ccpxx.kpjson && <>
            <Paragraph>开票类型：{ccpxx.kpjson[0].p_n3}  </Paragraph>
            <Paragraph>开票名称：{ccpxx.kpjson[0].p_n1}  </Paragraph>
            <Paragraph>信用代码：{ccpxx.kpjson[0].p_n4}  </Paragraph>
            <Paragraph>对公账户：{ccpxx.kpjson[0].p_n6}  </Paragraph>
            <Paragraph>开户银行：{ccpxx.kpjson[0].p_n5}  </Paragraph>
            <Paragraph>通讯地址：{ccpxx.kpjson[0].p_n7}  </Paragraph>
            <Paragraph>联系电话：{ccpxx.kpjson[0].p_n8}  </Paragraph>
          </>}

          <Paragraph>开票金额：{ccpxx.amount} </Paragraph>






          <Upload {...props} >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>



        </Modal>



      </ConfigProvider>
    </>

  );
};
export default Hfpsc;